var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"page-board-add"}},[_c('vx-card',{staticClass:"mb-base",attrs:{"title":"게시글 추가"}},[_c('board-add-form',{staticClass:"mt-4"})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }